import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app.module';
import { ENV } from '@app/env';

platformBrowserDynamic().bootstrapModule(AppModule)
  .then(() => {
    registerServiceWorker();
    // registerFacebookApp();
  });

function registerServiceWorker() {
  if (ENV.mode === 'Production') {
    if ('serviceWorker' in navigator) {
      window.addEventListener('load', function () {
        navigator.serviceWorker.register('/sw.js').then((reg) => {
          if (!navigator.serviceWorker.controller) {
            return;
          }
          if (reg.waiting) {
            updateReady(reg.waiting);
          }
          if (reg.installing) {
            updateReady(reg.installing);
            return;
          }
          reg.addEventListener('updatefound', function () {
            console.log('Actualización encontrada');
            updateReady(reg.installing);
          });

          // reg was successful
          console.log('ServiceWorker reg successful with scope: ', reg.scope);
        }).catch(function (err) {
          // reg failed :(
          console.log('ServiceWorker reg failed: ', err);
        });
        return;
      });
    }
  }
}

function updateReady(worker) {
  if (worker.state === 'installed') {
    console.log('New version Available');
    showToast();
    sendSkipWaiting(worker);
  }
  worker.addEventListener('statechange', () => {
    console.log('Escuchando cambios');
    switch (worker.state) {
      case 'installed':
        console.log('New version Available');
        showToast();
        window['updateAvailabl'] = true;
        console.warn('Check Variable');
        sendSkipWaiting(worker);
    }
  });
}

function showToast() {
  document.body.innerHTML += `<div id="snackbar">
<div class="symbol">⚠</div>
Nueva Versión Disponible
<br> Presione <span class="here">aquí</span> para descargarla
</div>`;
  const x = document.getElementById('snackbar');
  x.className = 'snackbar show';
}

function sendSkipWaiting(worker) {
  const x = document.getElementById('snackbar');
  x.addEventListener('click', () => {
    worker.postMessage({ action: 'skipWaiting' });
    window.location.reload(true);
  });
}

// function registerFacebookApp() {
//   console.log('Registrando FB App');
//   (function (d, s, id) {
//     var js, fjs = d.getElementsByTagName(s)[0];
//     if (d.getElementById(id)) { return; }
//     js = d.createElement(s); js.id = id;
//     js.src = "https://connect.facebook.net/en_US/sdk.js";
//     fjs.parentNode.insertBefore(js, fjs);
//   }(document, 'script', 'facebook-jssdk'));

//   (<any>window).fbAsyncInit = function () {
//     (<any>window).FB.init({
//       appId: '1912744835703731',
//       autoLogAppEvents: true,
//       xfbml: true,
//       version: 'v2.12'
//     });
//   };

// }


//reactor.dispatchEvent('big bang');



// WEBPACK FOOTER //
// ./src/app/main.ts